import { type ClusterGroup } from "../types/types";
import { type SearchResultData } from "../../utils/models";
import { type HSATabularColumnConfig, SearchReason } from "~/HousingSelectionAssistant/redux/types";

export const LOAD_INITIAL_DATA = "HSA: Load initial data";
export const LOAD_CONFIGURATION = "HSA: Load configuration data";
export const BEGIN_SEARCH = "HSA: Begin search";
export const HSA_SEARCH_SUCCESS = "HSA: Search success";
export const SEARCH_FAIL = "HSA: Search fail";

export function loadInitialDataAction(
  metricColumnConfig: HSATabularColumnConfig[],
  imperialColumnConfig: HSATabularColumnConfig[],
  clusterGroups: ClusterGroup[],
  searchResults: SearchResultData
) {
  return {
    type: LOAD_INITIAL_DATA,
    payload: {
      metricColumnConfig,
      imperialColumnConfig,
      clusterGroups,
      searchResults,
      searchReason: SearchReason.FILTER,
    },
  } as const;
}

export function beginSearchAction(searchReason: SearchReason) {
  return {
    type: BEGIN_SEARCH,
    payload: searchReason,
  } as const;
}

export function searchSuccessAction(searchResults: SearchResultData, searchReason: SearchReason) {
  return {
    type: HSA_SEARCH_SUCCESS,
    payload: {
      searchResults,
      searchReason,
    },
  } as const;
}

export function searchFailAction() {
  return {
    type: SEARCH_FAIL,
  } as const;
}

export type HSAActions =
  | ReturnType<typeof loadInitialDataAction>
  | ReturnType<typeof beginSearchAction>
  | ReturnType<typeof searchSuccessAction>
  | ReturnType<typeof searchFailAction>;
